export default {
  url: {
    ko: 'https://boryung.co.kr/',
    en: 'https://boryung.co.kr/en/',
  },
  title: {
    ko: '(주)보령',
    en: 'BORYUNG',
  },
  sitename: {
    ko: '(주)보령',
    en: 'BORYUNG',
  },
  description: {
    ko: '헬스케어기업 보령. CEO Letter, 제약사업, R&D, Humans In Space 등 정보 제공',
    en: 'BORYUNG',
  },
  keywords: {
    ko: 'boryung, 보령, 보령 홈페이지',
    en: 'BORYUNG',
  }
}
